export default __webpack_public_path__ + "static/media/z-Connect - Payments (EU) _ Revolut.eebc57ae.pdf";